"use client";

import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheStrategicEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="71573" id="consulting-strategy" className="w-full bg-background border-y border-border overflow-hidden dark">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[80vh]">
        {}
        <div className="lg:col-span-7 relative h-[50vh] lg:h-auto p-4 md:p-8 lg:p-12 border-b lg:border-b-0 lg:border-r border-border bg-muted/10 flex flex-col">
          <div className="w-full h-full relative border border-primary p-2 flex-grow">
            <div className="w-full h-full relative overflow-hidden bg-muted">
              <img src="https://bursting-osprey.10web.cloud/wp-content/uploads/2026/04/1-ChatGPT-Image-Mar-10-2026-02_35_42-PM.png" alt="Executive Strategic Dashboard" className="w-full h-full object-cover grayscale hover:grayscale-[0.2] transition-all duration-1000" />
              <div className="absolute inset-0 bg-primary/10 pointer-events-none" />
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-5 flex flex-col justify-center p-8 md:p-12 lg:p-16 xl:p-24 bg-background">
          <div ref={ref} className={`space-y-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <Badge variant="secondary" className="rounded-none px-4 py-2 text-xs tracking-[0.2em] uppercase bg-secondary text-secondary-foreground border-none font-default">
              Executive Strategy
            </Badge>

            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl text-foreground leading-[1.1] tracking-tighter font-bold">
              The sovereign standard for automated growth.
            </h2>

            <div className="space-y-6 text-muted-foreground text-lg leading-[1.6] font-default">
              <p>
                At AGS Partners, we architect high-performance ecosystems that
                transform operational complexity into kinetic growth. We help
                ambitious firms deploy Automated Growth Systems frameworks that scale with
                mathematical precision and executive-grade stability.
              </p>
              <p>Our operational and advisory background, rooted in driving meaningful business growth, delivers DFY, DWY, custom and DIY SaaS models. We provide the technical intelligence and strategic oversight so you can grow and dominate your market while maintaining absolute control.</p>
            </div>

            <div className="pt-12 flex justify-end border-t border-border/50">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}